import React, { useMemo } from 'react';
import { getSkillBookingStatus } from '@/utilities';
import { MasteryTimeBooked } from '@/enums';
import TimeToGrowthIcon from "../../../../src/features/planner/icons/time-to-growth-icon.svg";
import InfoIcon from "../../../../src/features/planner/icons/infoicon.svg";
import StopwatchIcon from '@/images/icons/stopwatch.svg';
import './AssignmentGrowth.scss';
import TimeToGrowthDurationEstimate from '@/components/shared/TimeToGrowthDurationEstimate';

const AssignmentGrowth = ({
  duration,
  timeToGrowth,
  skillBookingStatus
}: {
  duration: number,
  timeToGrowth: number | string
  skillBookingStatus: MasteryTimeBooked
}) => {
  const warning = useMemo(() => [MasteryTimeBooked.OVER_BOOKED, MasteryTimeBooked.UNDER_BOOKED].includes(skillBookingStatus), [skillBookingStatus])
  return (
  <div className="assignment-growth">
    <div className="time-to-growth d-flex justify-content-between align-items-center">
      <div className="time-to-growth-title d-flex justify-content-center align-items-center gap-1 px-3">
        <span className="time-to-growth-title-text">TIME TO GROWTH</span>
        <img src={InfoIcon} alt="info" className="time-to-growth-info-icon"/>
      </div>
      <TimeToGrowthDurationEstimate duration={timeToGrowth} timeToGrowthIcon={TimeToGrowthIcon}/>
    </div>
    <div className="time-assigned d-flex justify-content-between align-items-center">
      <div className="time-assigned-total d-flex flex-column justify-content-center align-items-center px-3">
        <span className="time-assigned-total-title-text">TIME ASSIGNED</span>
      </div>
      <TimeToGrowthDurationEstimate duration={duration} warning={warning} timeAssignedIcon={StopwatchIcon} />
    </div>
  </div>
  )
};

export default AssignmentGrowth;